import React from "react";
import PropTypes from 'prop-types';

export default class StoryPointsOptions extends React.Component {

    static propTypes = {
        menuParams: PropTypes.object,
        hidePopover: PropTypes.func
    };

    onSelect = (id) => {this.props.menuParams.onSelect(id); this.props.hidePopover();}

    onCustomize = () => {
        this.props.hidePopover()
        gd.modules.storyPoints.goToSettings()
    }

    render() {
        const options = gd.session.companies.get(gd.companyId).settings.fields.storyPoints;
        const isManager = gd.ac.check.company.isManager(gd.companyId);

        return (
            <div className={Classes("ui5-popover-selector", "cards-selector", {"with-help": isManager})}>
                <div className="ui5-title-tiny popover-title ">Story points</div>
                <div className="cards">
                    {_.map(options, (option, key)=>
                        <div key={key}
                             className={Classes("ui5-story-points", "s-40", "m-r-15", "m-b-15", {selected: this.props.menuParams.value === option.value})}
                             onClick={()=>{this.onSelect(option.value)}}>
                            {option.label}
                        </div>)}
                    <div className="ui5-story-points s-40 m-r-15 m-b-15 not-set" onClick={()=>{this.onSelect(null)}}></div>
                </div>

                {isManager &&
                <div className="help">
                    <div className="ui5-link-small" onClick={this.onCustomize}>Customize</div>
                </div>}
            </div>
        )
    }
}